import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import introJs from 'intro.js/intro.js';


import { MainService } from '../main.service';
import { AuthService } from '../auth.service';
import { NewReleaseService } from './new-release.service';

import { SelectItem, Message } from 'primeng/primeng';
import { environment } from '../../environments/environment';

import { FileUploader } from 'ng2-file-upload';
import { Pro } from './project';

// const URL = environment.uploadURL;
const URL = "/upload"

@Component({
    selector: 'new-release',
    templateUrl: './new-release.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['../../style.scss',
        './new-release.component.css',
    ]
})

// tslint:disable-next-line:directive-selector
// @Directive({ selector: '[ng2FileSelect]' })

// tslint:disable-next-line:directive-selector
// @Directive({ selector: '[ng2FileDrop]' })


export class NewReleaseComponent implements OnInit {
    releaseForm: FormGroup;

    selectedProject: Pro;
    selectedComponent: any;
    selectedVersion: any;
    selectedReleaseOwner: Pro;
    selectedQA: Pro;
    selectedDescription;
    selectedWorkFlow;
    projects: Pro[];
    projectList: Pro[];
    options: {};
    componentOptions: {};
    projectOptions: {};
    userOptions: {};
    versionOptions: {};
    versionListOptions: {};
    activityOptions: {};
    emailOptions: {};
    releaseDataOptions: {};
    componentList: Pro[];
    userList: Pro[];
    workFlowList: any;
    versionList: any;
    lastVersionList: any;
    skipComment;
    sendSkipCmt: string;

    fileName: string;
    fileName_Note: string;
    fileName_Test: string;
    originalFileName: string;
    originalFileName_Note: string;
    originalFileName_Test: string;
    isUploaded: boolean = false;
    isSaved: boolean = false;
    isFileSelected: boolean = false;
    isNoteSelected: boolean = false;
    isTestCaseSelected: boolean = false;
    cities: SelectItem[];
    filteredUserMultiple: any[];

    projectName: string;
    componentName: string;
    versionSelected: string;
    binaryFile: boolean = false;
    enableUpload: boolean = false;
    enableReleaseUpload: boolean = false;
    showLastComp: boolean = false;
    isSkipNote: boolean = true;
    buildSelected: boolean = false;

    msgs: Message[];
    responce: any;
    activityResponce: any;
    clickedOnce: boolean;
    showVersion: boolean;
    binaryDIR: String;
    noteDIR: String;
    testCaseyDIR: String;
    fileStatus: any[] = [];

    date = new Date();
    userEmail = localStorage.getItem('userEmail');
    userName = localStorage.getItem('userName');

    // session details
    // sessionCreatedTime = localStorage.getItem('sessionCreatedTime');
    // sessionTime = new Date(parseInt(this.sessionCreatedTime));
    // // sessionCreatedTime = new Date(sessionTime.getTime() +1200000);
    // sessionExpireTime = Number(new Date(this.sessionTime.getTime() + 14400000));

    sessionExpireTime = parseInt(localStorage.getItem('sessionExpireTime'))

    // session validation
    isValidSession() {
        if (this.date.getTime() >= this.sessionExpireTime) {
            this.authService.logout();
            this.router.navigate(['/Login']);
        }
    };


    fileEvent(e: any) {

        // this.fileStatus = 'Binary';
        this.fileStatus.push('Binary');

        this.enableReleaseUpload = true;

        this.binaryFile = true;
        this.isFileSelected = true;
        let file = e.target.files[0];

        this.originalFileName = file.name;
        console.log("this.originalFileName", this.originalFileName);

        // Used substring to get only the file name
        this.fileName = file.name.substring(0, file.name.lastIndexOf('.'));
    }

    fileEventNote(e: any) {

        // this.fileStatus = 'Release_Notes';
        this.fileStatus.push('Release_Notes');

        this.isNoteSelected = true;

        let file = e.target.files[0];

        this.originalFileName_Note = file.name;
        console.log("this.originalFileName_Note", this.originalFileName_Note);
        // Used substring to get only the file name
        this.fileName_Note = file.name.substring(0, file.name.lastIndexOf('.'));
    }

    fileEventTest(e: any) {

        // this.fileStatus = 'Test_Cases';
        this.fileStatus.push('Test_Cases');

        this.isTestCaseSelected = true;

        let file = e.target.files[0];

        this.originalFileName_Test = file.name;

        // Used substring to get only the file name
        this.fileName_Test = file.name.substring(0, file.name.lastIndexOf('.'));

    }


    getComponents() {
        this.mainService.getComponents(this.componentOptions).then(components => {
            this.componentList = components;
            console.log("components", this.componentList);
        });

    }

    getUsers() {
        this.mainService.getUsers(this.userOptions).then(users => {
            this.userList = users;
            console.log("users", this.userList);
        });

    }

    getVersion() {
        this.mainService.getVersions(this.versionListOptions).then(versions => {
            this.versionList = versions;
            console.log("versions", this.versionList);
        });
    }


    getLastVersion() {

        this.newReleaseService.getLastVersionForComponentTest(this.versionOptions).then(lastVer => {

            this.lastVersionList = lastVer;
            if (JSON.stringify(lastVer) == '{}') {
                this.showLastComp = false;
            } else {
                this.showLastComp = true;
            }

        });
    }


    getWorkflow() {
        this.mainService.getWorkflow(this.options).then(workflow => {
            this.workFlowList = workflow;

            this.releaseForm.patchValue({
                workflow: this.workFlowList[1]
            }
            );
        });


    }

    constructor(private fb: FormBuilder,
        private mainService: MainService,
        private authService: AuthService,
        private newReleaseService: NewReleaseService,
        private router: Router,
        private route: ActivatedRoute,) {

    }

    public uploader: FileUploader = new FileUploader({ url: URL });
    public hasBaseDropZoneOver = false;
    public hasAnotherDropZoneOver = false;

    public uploadData() {

        this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
            this.msgs = [];
            this.msgs.push({ severity: 'info', summary: 'Uploaded', detail: item.file.name });
            if (response) {
                console.log("response: ",response);
                console.log("status",status);
                console.log("headers",headers);
                if (response.includes("Binary")) {
                    this.binaryDIR = response;
                } else if (response.includes("Release_Notes")) {
                    this.noteDIR = response;
                } else if (response.includes("Test_Cases")) {
                    this.testCaseyDIR = response;
                } else {
                    console.log("DIR Err");
                    this.msgs.push({ severity: 'Error', summary: 'Upload Error' });
                    this.clickedOnce = false;
                }
            } else {
                this.msgs.push({ severity: 'Error', summary: 'Upload Error' });
                this.clickedOnce = false;
            }

            this.isUploaded = true;
        };


        this.uploader.onCompleteAll = () => {

            this.isUploaded = true;

            setTimeout(() => {
                this.msgs = [];
                this.msgs.push({ severity: 'info', summary: 'Don\'t Forget to hit the \'Save\' Button !!' });
            },
                1500);

        };

        this.uploader.onErrorItem = (item: any, response: any, status: any, headers: any) => {
            this.msgs = [];
            this.msgs.push({ severity: 'Error', summary: 'Upload Failed' });
            this.clickedOnce = false;
        };
    }

    public removeFile() {
        this.enableReleaseUpload = true;
        this.enableUpload = true;
        this.buildSelected = true;
    }

    public removeFiles() {
    }


    public fileOverBase(e: any): void {
        this.hasBaseDropZoneOver = e;
    }

    public fileOverAnother(e: any): void {
        this.hasAnotherDropZoneOver = e;
    }

    ngOnInit(): void {

        localStorage.removeItem('previousURL');

        this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
            form.append('project', this.projectName);
            form.append('component', this.componentName);
            form.append('type', this.fileStatus[0]);
            form.append('version', this.selectedVersion.version);

            this.fileStatus.shift();;
        };

        this.showVersion = (this.route.snapshot.url[0].path === 'New-Release');


        if (RegExp('intro', 'gi').test(window.location.search)) {

            introJs().setOptions({
                'doneLabel': '<span style="color: green; font-weight:bold;">Next page</span>',
                'keyboardNavigation': 'false',
                steps: [{
                    element: '#stepN01',
                    intro: 'First You have to select a project. <br> You can only see projects you are assigned.',
                    position: 'bottom'
                },
                {
                    element: '#stepN02',
                    intro: 'Now you can select a component which is already added to the project',
                    position: 'bottom'
                },
                {
                    element: '#stepN03',
                    intro: 'A list of Versions will be displayed according to the Component you selected.',
                    position: 'bottom'
                },
                {
                    element: '#stepN04',
                    intro: 'You can add email addresses you need to send the release email',
                    position: 'bottom'
                },
                {
                    element: '#stepN05',
                    intro: 'Add the Release Build. This is Mandatory.',
                    position: 'bottom'
                },
                {
                    element: '#stepN06',
                    intro: 'You can add Release Note.',
                    position: 'bottom'
                },
                {
                    element: '#stepN07',
                    intro: 'Or you can skip the release note by adding a comment.',
                    position: 'bottom'
                },
                {
                    element: '#stepNMsg',
                    intro: '<b> Don\'t Forget to Upload the files & Save the Release. </b>',
                    position: 'bottom'
                },
                {
                    element: '#stepNL',
                    intro: '<b> Next We\'ll take a look at Release Bundle. </b>',
                    position: 'bottom'
                }]
            })
                .start()
                .oncomplete(function () {
                    window.location.href = '/Release-Bundles?intro=true';
                });
        }

        this.releaseForm = this.fb.group({
            project: ['', Validators.required],
            component: ['', Validators.required],
            owner: ['', Validators.required],
            qa: [''],
            others: [''],
            teamEmail: [''],
            version: ['', Validators.required],
            description: ['', Validators.required],
            workflow: [{ value: '', disabled: true }],
            skipReleaseNote: [{ value: true, disabled: true }],
            allVersions: [{ value: false, disabled: true }]
        });

        this.isValidSession();

        this.getWorkflow();

        this.projectOptions = {
            user: this.userEmail
        };

        this.mainService.getProjectList(this.projectOptions).then(projects => {
            this.projectList = projects;
        });


        var project = '';

        this.releaseForm.get('project').valueChanges.subscribe(proj => {
            if (proj != undefined) {
                this.projectName = proj.key;
                this.componentOptions = {
                    id: proj.id,
                    list: '',
                    user: this.userEmail
                };

                project = proj.id;
                this.getComponents();

                this.userOptions = {
                    id: proj.id,
                    role: ''
                };

                this.getUsers();

            }

        })

        this.releaseForm.get('component').valueChanges.subscribe(comp => {
            if (comp != undefined) {
                this.componentName = comp.component;

                this.versionOptions = {
                    component: comp.id
                };

                this.versionListOptions = {
                    id: project,
                    component: comp.component,
                    editMode: ''
                }

                this.getVersion();

                if (this.componentName != undefined && this.projectName != undefined) {
                    this.releaseForm.controls['allVersions'].enable();
                }

                this.getLastVersion();

            }

        })

        this.releaseForm.get('version').valueChanges.subscribe(vers => {
            if (vers != undefined) {
                this.versionSelected = vers.version;

            }

            if (this.componentName != undefined && this.projectName != undefined && this.versionSelected != undefined) {
                this.enableReleaseUpload = true;
                this.enableUpload = true;
                this.releaseForm.controls['skipReleaseNote'].enable();
            }

        })

        this.releaseForm.get('skipReleaseNote').valueChanges.subscribe(isSkip => {
            if (isSkip != undefined) {
                this.isSkipNote = isSkip;
            }

        })

        this.releaseForm.get('allVersions').valueChanges.subscribe(isAll => {
            if (isAll != undefined) {

                if (isAll) {
                    this.versionListOptions = {
                        id: project,
                        component: '',
                        editMode: ''
                    }

                    // loading version when all option selected
                    this.getVersion();
                } else {
                    this.versionListOptions = {
                        id: project,
                        component: this.componentName,
                        editMode: ''
                    }
                    // loading version when all option selected
                    this.getVersion();

                }
            }

        })

    }

    closeSkipComment() {
        this.isSkipNote = true;
        this.releaseForm.patchValue({
            skipReleaseNote: true
        }
        );
    }

    filterEmailMultiple(event) {
        let query = event.query;
        if (this.userOptions != undefined) {
            this.mainService.getUsers(this.userOptions).then(users => {
                this.filteredUserMultiple = this.filterUser(query, users);
                if (this.filteredUserMultiple.length == 0) {
                    this.msgs = [];
                    this.msgs.push({ severity: 'warn', summary: 'Please Enter a valid email !' });
                    this.clickedOnce = false;
                }
            });
        } else {
            this.msgs = [];
            this.msgs.push({ severity: 'warn', summary: 'Please Select a Project First !' });
            this.clickedOnce = false;
        }
    }

    filterUser(query, users: any[]): any[] {
        //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
        let filtered: any[] = [];
        for (let i = 0; i < users.length; i++) {
            let user = users[i];
            if (user.name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                filtered.push(user);
            }
        }
        return filtered;
    }

    addSkipComment() {
        if (this.skipComment == undefined) {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Empty Comment' });
            this.clickedOnce = false;
        } else if (this.skipComment.length < 20) {
            this.msgs = [];
            this.msgs.push({ severity: 'warn', summary: 'Comment Too Short' });
            this.clickedOnce = false;
        } else {
            var sendSkipCmt = this.skipComment;

            this.sendSkipCmt = (sendSkipCmt.replace("<p>", "")).replace("</p>", "");

            this.msgs = [];
            this.msgs.push({ severity: 'success', summary: 'Comment Added' });
            this.isSkipNote = true;
        }

    }

    save() {

        this.clickedOnce = true;
        if (this.releaseForm.valid) {
            if (this.isUploaded) {
                if (this.fileName_Note != undefined || this.isSkipNote == false || (this.isSkipNote == true && this.skipComment != undefined)) {
                    var sendDesc = this.stripHTML(this.stripHTML(this.selectedDescription));

                    if (this.skipComment != undefined) {
                        var userSkipComm = this.skipComment;
                        var sendSkipComm = (userSkipComm.replace("<p>", "")).replace("</p>", "");
                    } else {
                        sendSkipComm = '-';
                    }

                    // release email
                    var ccList = this.selectedReleaseOwner.email;
                    if (this.releaseForm.get('others').value) {
                        for (var i = 0; i < this.releaseForm.get('others').value.length; i++) {
                            ccList = ccList + "," + this.releaseForm.get('others').value[i].email;
                        }
                    }

                    if (this.releaseForm.get('teamEmail').value) {
                        for (var i = 0; i < this.releaseForm.get('teamEmail').value.length; i++) {
                            ccList = ccList + "," + this.releaseForm.get('teamEmail').value[i];
                        }
                    }

                    this.options = {
                        project: this.selectedProject.id,
                        component: this.selectedComponent.id,
                        version: this.selectedVersion.version,
                        desc: sendDesc,
                        fileName: this.fileName,
                        owner: this.selectedReleaseOwner.id,
                        qa: this.selectedQA ? this.selectedQA.name : '',
                        destination: this.binaryDIR,
                        // destination: '../Uploads/Binary/' + this.projectName + '/' + this.componentName + '/' + this.fileName + '/' + this.originalFileName,
                        note: this.fileName_Note ? this.fileName_Note : '',
                        relaseNote: this.originalFileName_Note ? this.noteDIR : '',
                        // relaseNote: this.originalFileName_Note ? '../Uploads/Release_Notes/' + this.projectName + '/' + this.componentName + '/' + this.fileName_Note + '/' + this.originalFileName_Note : '',
                        test: this.fileName_Test ? this.fileName_Test : '',
                        testCases: this.originalFileName_Test ? this.testCaseyDIR : '',
                        // testCases: this.originalFileName_Test ? '../Uploads/Test_Cases/' + this.projectName + '/' + this.componentName + '/' + this.fileName_Test + '/' + this.originalFileName_Test : '',
                        uploaded_by: this.userName,
                        workflow: this.selectedWorkFlow.id,
                        skipComment: sendSkipComm,
                        cc: ccList
                        // worflow: '1', // Dev is default workflow ID - 1
                    };


                    this.activityOptions = {
                        user: this.userEmail,
                        action: "Upload",
                        file: this.fileName
                    };

                    this.newReleaseService.sendActivity(this.activityOptions).then(res => {
                        this.activityResponce = res;
                    });


                    this.emailOptions = {
                        fromEmail: this.userEmail,
                        fromUser: this.userName,
                        toEmail: this.selectedQA ? this.selectedQA.email : this.selectedReleaseOwner.email,
                        toUser: this.selectedQA ? this.selectedQA.name : this.selectedReleaseOwner.name,
                        subject: this.selectedVersion.version,
                        version: this.selectedVersion.version,
                        project: this.selectedProject.name,
                        // cc: this.selectedReleaseOwner.email,
                        cc: ccList,
                        component: this.selectedComponent.component,
                        desc: sendDesc
                    };

                    this.sendReleaseData(this.emailOptions);
                } else {
                    this.msgs = [];
                    this.msgs.push({ severity: 'warn', summary: 'Upload Release Note or Skip by adding the Reason' });
                    this.clickedOnce = false;
                }
            } else {
                this.msgs.push({ severity: 'error', summary: 'Upload Release' });
                this.clickedOnce = false;
            }


        } else {
            this.validateAllFormFields(this.releaseForm);
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Form is not Complete', detail: 'Please Check the Entered Data' });
            this.clickedOnce = false;
        }
    }

    stripHTML(html) {
        var tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText;
    }

    sendReleaseData(email) {

        this.newReleaseService.sendRelease(this.options).then(res => {
            this.responce = res;

            if (this.responce.status == 'sent') {
                this.isSaved = true;

                this.msgs = [];
                this.msgs.push({ severity: 'success', summary: 'Saved' });

                this.clickedOnce = true;

                this.emailOptions = {
                    fromEmail: email.fromEmail,
                    fromUser: email.fromUser,
                    toEmail: email.toEmail,
                    toUser: email.toUser,
                    subject: email.subject,
                    version: email.version,
                    project: email.project,
                    // cc: this.selectedReleaseOwner.email,
                    cc: email.cc,
                    component: email.component,
                    desc: email.desc,
                    index: this.responce.index
                }

                this.newReleaseService.sendReleaseEmail(this.emailOptions).then(res => {
                    this.activityResponce = res;
                });

                setTimeout(() => {
                    this.router.navigate(['/Home']);
                },
                    1000);
            } else {
                this.clickedOnce = false;
                this.msgs = [];
                this.msgs.push({ severity: 'error', summary: this.responce, detail: '' });
            }

        });
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }

    // Deactivate route guard
    //some behaviour that change the loading value
    canDeactivate() {
        if (this.releaseForm.dirty == true && this.isSaved != true ||
            (this.releaseForm.valid == true && this.isSaved != true) ||
            (this.isUploaded == true && this.isSaved != true)) {
            return window.confirm('Do you want to Discard Changes?');
        } else {
            return true;
        }
    }
}
